var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColorAdjustment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Color adjustment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color-adjustment",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(-0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 24.0000001 0 24.0000001 24.0000001 0 24.0000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25100003,21.5020001 C4.80400002,21.5020001 2.00000001,18.6980001 2.00000001,15.2510001 C2.00000001,11.804 4.80400002,9.00000004 8.25100003,9.00000004 C11.698,9.00000004 14.5020001,11.804 14.5020001,15.2510001 C14.5020001,18.6980001 11.698,21.5020001 8.25100003,21.5020001 Z",
    stroke: "#BABABA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7490001,21.5020001 C12.3020001,21.5020001 9.49800004,18.6980001 9.49800004,15.2510001 C9.49800004,11.804 12.3020001,9.00000004 15.7490001,9.00000004 C19.1960001,9.00000004 22.0000001,11.804 22.0000001,15.2510001 C22.0000001,18.6980001 19.1960001,21.5020001 15.7490001,21.5020001 Z",
    stroke: "#BABABA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0100001,15.0000001 C8.56300004,15.0000001 5.75900002,12.1960001 5.75900002,8.74900004 C5.75900002,5.30200002 8.56300004,2.49800001 12.0100001,2.49800001 C15.4570001,2.49800001 18.2610001,5.30200002 18.2610001,8.74900004 C18.2610001,12.1960001 15.4570001,15.0000001 12.0100001,15.0000001 Z",
    stroke: "#BABABA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorAdjustment);
export default __webpack_public_path__ + "static/media/ColorAdjustment.b6d05bdf7afee9d2b5d2d047114ff5d2.svg";
export { ForwardRef as ReactComponent };